import { Grid, Paper,Typography } from '@mui/material'
import React from 'react'
import PersonalDetails from '../createLead/PersonalDetails'
import Leadinfo from '../createLead/LeadInfo'

function LeadCreatePop() {
    const paperStyle = { padding: '30px 20px', width: 300, margin: "20px auto" }
    const headerStyle = { margin: 0 }

  return (
    <Grid>
        <Paper style={paperStyle}>
        <Grid>
            <h2 style={headerStyle}>Before Proceeding</h2>
            <Typography variant='caption' gutterBottom>Please fill this form to create an account !</Typography>
        </Grid>
            <Grid>
                <Leadinfo />
            </Grid>
        </Paper>
    </Grid>
  )
}

export default LeadCreatePop